import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  createTransaction: {
    id: 'createTransaction',
    defaultMessage: 'Create transaction',
  },
  transactionDate: {
    id: 'transactionDate',
    defaultMessage: 'Select transaction date',
  },
  transactionPeriod: {
    id: 'transactionPeriod',
    defaultMessage: 'Select transaction period',
  },
  selectPeriodRange: {
    id: 'selectPeriodRange',
    defaultMessage: 'Select start and end',
  },
  debitOrCredit: {
    id: 'debitOrCredit',
    defaultMessage: 'Select income type',
  },
  amount: {
    id: 'amount',
    defaultMessage: 'Amount',
  },
  not_zero: {
    id: 'not_zero',
    defaultMessage: 'Amount can not be 0',
  },
  invalid_range: {
    id: 'invalid_range',
    defaultMessage: 'Value must be a date range',
  },
  day30Info: {
    id: 'day30Info',
    defaultMessage:
      "If there is no 31st day of the month, we'll automatically perform the transaction on the last day of each month.",
  },
  dayEvery: {
    id: 'dayEvery',
    defaultMessage: 'Every:',
  },
  oneTime: {
    id: 'oneTime',
    defaultMessage: 'One-time',
  },
  monthEnd: {
    id: 'monthEnd',
    defaultMessage: 'Every month-end',
  },
  quarterEnd: {
    id: 'quarterEnd',
    defaultMessage: 'Every quarter-end',
  },
  fixedDay: {
    id: 'fixedDay',
    defaultMessage: 'Fixed day every month',
  },
});

export default { ...globalIntl, ...m };
